<template>
  <div ref="videoContainer" class="video-container">
    <audio
        v-if="this.videoData.extensionCategory === 'audio'"
        ref="videoPlayer"
        class="video-js vjs-big-play-centered"
      ></audio>
      <video
        v-else
        ref="videoPlayer"
        class="video-js vjs-big-play-centered"
      ></video>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  name: 'VideoPlayer',
  props: {
    videoData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      player: null
    }
  },
  mounted () {
    this.player = videojs(this.$refs.videoPlayer, {
      controls: true,
      sources: [{
        type: `${this.videoData.extensionCategory}/${this.videoData.format}`,
        src: this.videoData.preview_url
      }]
    })
  },
  beforeUnmount () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="postcss" scoped>
.video-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;

  & .video-js {
    width: 100%;
    height: 100%;
  }
}
</style>
